<div
  class="modal fade"
  id="staticTermsBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticTermsBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close button"
          aria-label="Close"
          id="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div class="modal-body">
        <h4 class="modal-title">Uslovi korišćenja</h4>
        <p>
          MAX BET DOO BEOGRAD, sa sedištem u ulici Bulevar heroja sa Košara 4a, Beograd (u daljem
          tekstu: MaxBet) je u agenciji za privredne registre u Srbiji zavedena pod brojem 07854293
          priređuje Igre na sreću preko sredstava elektronske komunikacije u skladu sa odobrenjem
          br. 000-424-00-00317/2015 , izdatim od strane Ministarstva finansija Republike Srbije -
          Poreska uprava - sektora za menjačke i devizne poslove i igre na sreću, određuje pravila,
          uslove učestvovanja u igri i zadržava pravo izmena ovih uslova u bilo kom trenutku bez
          prethodnog obaveštenja. Za sve promene pravila i uslova koji budu usledili, MaxBet se
          obavezuje da će obavestiti klijente putem emaila ili putem obaveštenja koje će biti
          istaknuto na sajtu www.maxbet.rs. MaxBet zadržava pravo da odbije opklade, delom ili u
          celosti bez objašnjenja, i da nakon uplate proglasi nevažećim kvotu koja je posledica
          greške od strane sistema ili priređivača, a ulog vrati igraču.
        </p>
        <p>Opklade se primaju po Zakonima Republike Srbije.</p>

        <p>
          Registracija i klađenje je zabranjeno osobama mlađim od 18 godina. Prihvatanjem ovih
          pravila učesnik potvrđuje da ima više od 18 godina.
        </p>
        <p>
          U slučaju da maloletno lice na neki nedozvoljeni način ipak otvori nalog na MaxBet web
          servisu, priređivač se obavezuje da će odmah po otkrivanju blokirati nalog maloletne
          osobe, uz napomenu da nema obavezu vraćanja uplaćenog depozita. MaxBet zadržava pravo da
          odbije zahtev za otvaranje naloga za klađenje i zadržava pravo da zatvori račun klijenta
          po sopstvenom nahođenju. Upotreba servisa može u potpunosti ili delimično da bude
          ograničena u nekim geografskim oblastima. MaxBet ne snosi odgovornost za registracije na
          servis i upotrebu servisa od strane korisnika sa teritorija na kojima je upotreba servisa
          zabranjena.
        </p>
        <h6>Otvaranje naloga</h6>

        <p>
          Nakon prihvatanja Pravila i uslova korišćenja, otvoriće se strana na kojoj se traže podaci
          za otvaranje naloga za korišćenje servisa koji uključuju: ime, prezime, matični broj,
          datum rođenja, važeću e-mail adresu, korisničko ime i lozinku, broj telefona, grad i
          zemlju. Za tačnost podataka odgovornost snosi lice koje otvara nalog. Neophodno je da je
          osoba koja se registruje starija od 18 godina, te da prihvata opšte uslove i politiku
          privatnosti MaxBet kladionice.
        </p>
        <p>
          Kada popunite sva obavezna polja i pošaljete zahtev za registraciju i otvaranje naloga na
          MaxBet web servisu, dobićete e-mail na Vašu e-mail adresu (koju ste prethodno registrovali
          na našoj aplikaciji) i od Vas će se tražiti da potvrdite svoju registraciju tako što ćete
          kliknuti na odgovarajući aktivacioni link. Nakon uspešne aktivacije, Vaš nalog će biti
          spreman i možete da počnete da koristite MaxBet online klađenje. Vrlo je važno da podaci
          koje ostavljate budu tačni i ispunjeni od strane osobe koja se registruje.
        </p>
        <p>
          MaxBet zadržava pravo da ne otvori ili zatvori nalog, ukoliko su informacije nepotpune ili
          netačne. Jednom igraču je dozvoljeno da otvori jedan nalog. Otvaranje više naloga nije
          dozvoljeno.
        </p>
        <p>
          Ukoliko MaxBet ima sumnje da je neko od klijenata otvorio više naloga, MaxBet ima pravo da
          zamrzne nalog klijenta ili da zatvori nalog odmah, a klijent gubi sve svoje podatke i
          stanja.
        </p>
        <ul>
          <b> Izričito je zabranjeno klijentima da:</b>
          <li>Igraju za treća lica.</li>

          <li>Deponuju novac koji potiče od kriminalne aktivnosti.</li>

          <li>
            Deponuju novac sa kartice za čije korišćenje nemaju ovlašćenje, ili svesno primaju novac
            sa kartice od drugih ili trećih lica i prosleđuju na svoj nalog.
          </li>

          <li>
            Koriste svoj nalog za bilo kakvo pranje novca ili bilo koje druge nezakonite radnje.
          </li>
        </ul>
        <p>
          Strogo je zabranjeno korišćenje nedozvoljenih radnji tipa nedozvoljeno menjanje programa,
          presecanje podataka, korišćenje raznih elektronskih, mehaničkih i drugih naprava koje
          donose odluke u bilo kojoj igri ili menjanje podataka kada je igra počela od strane
          vlasnika naloga ili nekoga za druga ili treća lica.
        </p>
        <p>
          MaxBet u slučaju bilo kakve sumnje na nedozvoljenu igru nije u obavezi da isplati dobitke
          i može teretiti sudskim putem takvog klijenta kao vršioca nedozvoljenih radnji po važećim
          zakonima.
        </p>
        <p>
          Da bi koristio usluge MaxBet web servisa, klijent mora imati važeći nalog sa dovoljnim
          sredstvima da može učestvovati u igri.
        </p>
        <p>Zahtev za otvaranje naloga se vrši popunjavanjem registracionog formulara.</p>
        <p>Minimalna uplata po nalogu je 20 dinara, a maksimalna isplata 5.000.000 dinara.</p>
        <p>
          MaxBet zadržava pravo da po svom nahođenju izmeni visinu minimalne uplate/isplate depozita
          po nalogu.
        </p>
        <p>
          MaxBet ne naplaćuje dodatne takse ili provizije na uplate depozita, osim onih koje banka
          naplati pri transakciji novca sa računa ili na račun klijenta (igrača).
        </p>
        <p>Sredstva deponovana na jedan nalog ne mogu biti deponovana na drugi nalog.</p>
        <p>
          Isplata depozita se vrši na bankovni račun igrača ili direktno na uplatnim mestima
          kladionica MaxBet uz prethodnu najavu o podizanju novca, a koja uključuje i lokaciju.
        </p>
        <p>
          MaxBet zadržava pravo da od igrača u bilo kom trenutku zatraži lični dokument u cilju
          utvrđivanja identiteta i starosti igrača. Priloženi lični dokument (kopiju kartice,
          računa, lične karte, pasoša, vozačke dozvole i dr.) mora biti izdat od zvanične
          institucije, a podaci na dokumentu moraju biti prikazani jasno i čitljivo. Takođe zadržava
          pravo da zahteva po potrebi dodatne informacije od igrača.
          <b
            >Potrebne dokumente igrač može priložiti u elektronskoj formi na e-mail:
            online&#64;maxbet.rs</b
          >
        </p>
        <p>
          Ako iz bilo kog razloga korisnik odbije ili nije u mogućnosti da bilo koji od traženih
          dokumenata dostavi, MaxBet zadržava pravo da zamrzne ili zatvori nalog, a korisnik gubi
          sve svoje dobitke i podatke. Sigurnost MaxBet naloga je isključivo briga korisnika.
          Korisnik ne sme dozvoliti pristup trećim licima svom nalogu. Korisnik je odgovoran da čuva
          u tajnosti lozinku koja omogućava pristup MaxBet nalogu. Korisnik je u obavezi da se po
          završetku korišćenja servisa na javnim mestima i deljenim računarima odjavi sa svog MaxBet
          naloga, i spreči treća lica da pristupe i koriste njegov MaxBet nalog.
        </p>
        <p>
          Korisnik prihvata potpunu odgovornost za sve posledice ukoliko svesno ili nesvesno dozvoli
          korišćenje svog naloga trećim licima.
        </p>
        <p>
          U slučaju da klijent posumnja ili ima saznanja da postoji mogućnost zloupotrebe njegovog
          naloga, u obavezi je da elektronskim putem (e-mail) i
          <b> pozivom call centra 011 44 22 444</b> prijavi nameru zloupotrebe i zatraži blokiranje
          svog naloga.
        </p>
        <p>
          MaxBet garantuje tajnost Vaših podataka i obavezuje se da Vaše lične podatke neće
          prosleđivati trećim licima, bez Vašeg saznanja i izričite dozvole. Vaši lični podaci mogu
          biti dati na uvid trećim licima samo na zahtev nadležnih državnih institucija. Bilo kakav
          nagoveštaj pranja novca MaxBet će prijaviti nadležnim organima. Ukoliko ne koristite svoj
          nalog 6 meseci od zadnjeg dana korišćenja MaxBet može zatvoriti nalog i o tome putem
          e-mail-a obavestiti klijenta. MaxBet zadržava pravo da posle 6 meseci nekorišćenja naloga
          sredstva prebaci na svoj račun i prosledi ih u <b>HUMANITARNE SVRHE</b>. Sve informacije i
          pitanja u vezi zatvaranja računa možete dobiti na e-mail: online&#64;maxbet.rs
        </p>
        <p>
          MaxBet postavlja uslove visine uplate kao i isplate, limitiranja tiketa, primanja i ne
          primanja uplate, isključivanja korisnika na određeno ili neodređeno vreme.
        </p>
        <p>
          MaxBet zadržava pravo promene limita uplate i isplate, a bez obaveze da o tome obavesti
          svoje klijente.
        </p>
        <p>
          Minimalni ulog iznosi 20 dinara po tiketu. Neophodna sredstva za korišćenje sistema moraju
          biti deponovana na nalog vlasnika naloga pre korišćenja. Korisnik izjavljuje da ne zna ili
          nije svestan ishoda događaja prilikom postavljanja odgovarajuće opklade. Početak utakmice
          se može menjati u zavisnosti od vremena početka utakmica i na to ne utiče MaxBet.
        </p>

        Obaveštenje o obradi podataka o ličnosti možete pogledati
        <a
          href="https://downloadsection.net/public/assets/docs/Obaves%CC%8Ctenje%20o%20obradi%20podataka%20o%20lic%CC%8Cnosti%20i%20o%20pravu%20na%20prigovor.pdf"
          target="_blank"
        >
          OVDE</a
        >.
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn--close"
          id="btn-ok"
          data-bs-dismiss="modal"
          data-bs-dismiss="modal"
          (click)="this.dialogService.closeDialog()"
        >
          U redu
        </button>
      </div>
    </div>
  </div>
</div>
